import * as React   from "react";
import ReactTooltip from 'react-tooltip';

import "./office-info-route.scss";

import {isApiTrue}      from "@Common/logic/is-api-true";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Responsive}     from "@Common/ui-components/responsive";

import {AddressEdit}    from "@Xpresso/routes/account/admin/office-management/office-management-route/management-modal/address-edit/address-edit";
import {InternalLink}   from "@Xpresso/routes/common/components/internal-link";

import {EmulationModal}      from "../../../common/emulation-modal/emulation-modal";
import {showOfficeEmulation} from "../../../common/logic/show-office-emulation";
import {MultiInputModal}     from "../../common/multi-input-modal/multi-input-modal";
import {PasswordUpdateModal} from "../../common/password-update-modal/password-update-modal";
import {OfficeLayout}        from "../common/office-layout";

export const AccountOfficeInfoRoute = () => cs(
    ({}, next) => OfficeLayout({activeTab: "office-info", next}),
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("company"),
    consumeContext("userLevels"),
    ["emulationModal", (_, next) => EmulationModal({next})],
    ["branch", ({session}, next) => next(session?.data?.branch)],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["generalData", ({branch}, next) => next(branch && parsebranchData({branch}))],
    ["generalModal", ({session, responsive, apis}, next) => MultiInputModal({
        next,
        title: "General Information",
        labelLocation: responsive.lt("mobile") ? "top" : "left",
        onSave: (updateFields) => (apis.next.session.updateBranch({updateFields})),
        reload: () => session?.reload(),
        urlParam: "general",
    })],
    ["customizationData", ({branch}, next) => next(branch && parseBranchDisplayData({branch}))],
    ["customizationModal", ({session, responsive, apis}, next) => MultiInputModal({
        next,
        title: "Customization Information",
        labelLocation: responsive.lt("mobile") ? "top" : "left",
        onSave: (updateFields) => (apis.next.session.updateBranch({updateFields})),
        reload: () => session?.reload(),
        urlParam: "customize",
    })],
    ["managePasswordModal", ({apis, branch}, next) => branch?.idUser ? PasswordUpdateModal({
        next,
        title: "Manage Office Password",
        onSave: apis.next.userProfile.updateUserProfile,
        targetUserId: branch.idUser,
        urlParam: "password",
    }) : next()],
    ({branch, userLevels, emulationModal, generalModal, generalData, customizationModal, customizationData, managePasswordModal, company, session}) => (
        !branch ? (
            <div className="office-info-route-x0y">
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            </div>
        ) : branch?.idBranch ? (
            <div className="office-info-route-x0y">
                <ReactTooltip  id="office-info-route" place="bottom" delayShow={100}/>
                <div className="section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="General Information">
                            General Information
                        </div>
                        {isApiTrue(company?.profile?.branchEditDisplay) && <a className="edit" xd-qa-type="link" xd-qa-name="Edit General Information" onClick={() => generalModal.show({data: generalData})}>
                            Edit
                        </a>}
                    </div>
                    <div className="card">
                        <div className="title" xd-qa-type="label" xd-qa-name="Branch Name">
                            {branch.branchName}
                        </div>
                        <div className="value" xd-qa-type="label" xd-qa-name="Branch Manager">
                            {branch.branchManagerName}
                        </div>
                        <div className="value" xd-qa-type="label" xd-qa-name="Branch Phone 1" data-for="office-info-route" data-tip={branch.branchPhone1}>
                            {branch.branchPhone1}
                        </div>
                        <div className="value" xd-qa-type="label" xd-qa-name="Branch Phone 2" data-for="office-info-route" data-tip={branch.branchPhone2}>
                            {branch.branchPhone2}
                        </div>
                        <div className="value" xd-qa-type="label" xd-qa-name="Branch Email">
                            {branch.branchEmail}
                        </div>
                        {(branch.branchAdmin1Name || branch.branchAdmin1Email || branch.branchAdmin2Name || branch.branchAdmin2Email) && <div className="vertical-split">
                            <div className="item">
                                <div className="label" xd-qa-type="label" xd-qa-name="Admin 1">
                                    Admin 1
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Branch Admin 1 Name" data-for="office-info-route" data-tip={branch.branchAdmin1Name}>
                                    {branch.branchAdmin1Name}
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Branch Admin 1 Email" data-for="office-info-route" data-tip={branch.branchAdmin1Email}>
                                    {branch.branchAdmin1Email}
                                </div>
                            </div>
                            {(branch.branchAdmin2Name || branch.branchAdmin2Email) && <div className="item">
                                <div className="label" xd-qa-type="label" xd-qa-name="Admin 2">
                                    Admin 2
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Branch Admin 2 Name" data-for="office-info-route" data-tip={branch.branchAdmin2Name}>
                                    {branch.branchAdmin2Name}
                                </div>
                                <div className="value" xd-qa-type="label" xd-qa-name="Branch Admin 2 Email" data-for="office-info-route" data-tip={branch.branchAdmin2Email}>
                                    {branch.branchAdmin2Email}
                                </div>
                            </div>}
                        </div>}
                    </div>
                </div>
                {AddressEdit({branch, reload: () => session?.reload(), loading: !branch, addressCard: true, readOnly: !company.prefs.allowEditOfficeAddress })}
                <div className="section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Customization Information">
                            Customization Information
                        </div>
                        {isApiTrue(company?.profile?.branchEditDisplay) && <a className="edit" xd-qa-type="link" xd-qa-name="Edit Customization Information" onClick={() => customizationModal.show({data: customizationData})}>
                            Edit
                        </a>}
                    </div>
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Cusomization Label">
                        You may use this information on product customization
                    </div>
                    {(branch["branchDisplay1"] || branch["branchDisplay2"] || branch["branchDisplay3"] || branch["branchDisplay4"] || branch["branchDisplay5"] || branch["branchDisplay6"]) && 
                        <div className="card">
                            <div className="value" xd-qa-type="label" xd-qa-name="Branch Display 1" data-for="office-info-route" data-tip={branch["branchDisplay1"]}>
                                {branch.branchDisplay1}
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name="Branch Display 2" data-for="office-info-route" data-tip={branch["branchDisplay2"]}>
                                {branch.branchDisplay2}
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name="Branch Display 3" data-for="office-info-route" data-tip={branch["branchDisplay3"]}>
                                {branch.branchDisplay3}
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name="Branch Display 4" data-for="office-info-route" data-tip={branch["branchDisplay4"]}>
                                {branch.branchDisplay4}
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name="Branch Display 5" data-for="office-info-route" data-tip={branch["branchDisplay5"]}>
                                {branch.branchDisplay5}
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name="Branch Display 6" data-for="office-info-route" data-tip={branch["branchDisplay6"]}>
                                {branch.branchDisplay6}
                            </div>
                        </div>
                    }
                </div>
                {branch.idUser && (
                    <div className="section">
                        <div className="header">
                            <div className="title" xd-qa-type="label" xd-qa-name="Manage Office Password">
                                Manage Office Password
                            </div>
                            <a className="edit" xd-qa-type="link" xd-qa-name="Edit Office Password" onClick={() => managePasswordModal.show()}>
                                Edit
                            </a>
                        </div>
                        {userLevels?.isGeneric === false && (
                            <div className="sub-title" xd-qa-type="label" xd-qa-name="Profile Password Helper Text">
                                Reset password for this shared office account. To update your personal password,&nbsp;
                                <InternalLink to="/account/my-profile" xd-qa-type="link" xd-qa-name="click here">click here</InternalLink>
                            </div>
                        )}
                    </div>
                )}
            </div>
        ) : (
            <div className="office-info-route-x0y">
                <div className="center">
                    {userLevels.userLevel !== 5 ? (<>
                        {"In order to see user details, you must "}
                        <a
                            className="emulation"
                            xd-qa-type="button"
                            xd-qa-name="Emulation"
                            onClick={() => emulationModal.show()}
                        >
                            {showOfficeEmulation(userLevels) ? (
                                "Select Office & User"
                            ) : (
                                "Select User"
                            )}
                        </a>
                    </>) : (
                        "Something went wrong"
                    )}
                </div>
            </div>
        )
    )
);

export const parsebranchData = ({branch}) => {
    return [
        {"label": <div xd-qa-type="label" xd-qa-name="Office Name">Office Name <span style={{color: "red"}}>*</span></div>, "value": branch.branchName, "mapping": "branchName", "maxLength": 80},
        {"label": <div xd-qa-type="label" xd-qa-name="Manager Name">Manager Name</div>, "value": branch.branchManagerName, "mapping": "branchManagerName", "maxLength": 40},
        {"label": <div xd-qa-type="label" xd-qa-name="Office Phone 1">Office Phone 1</div>, "value": branch.branchPhone1, "mapping": "branchPhone1", "maxLength": 25},
        {"label": <div xd-qa-type="label" xd-qa-name="Office Phone 2">Office Phone 2</div>, "value": branch.branchPhone2, "mapping": "branchPhone2", "maxLength": 25},
        {"label": <div xd-qa-type="label" xd-qa-name="Office Email">Office Email <span style={{color: "red"}}>*</span></div>, "value": branch.branchEmail, "mapping": "branchEmail", "maxLength": 60},
        {"label": <div xd-qa-type="label" xd-qa-name="Admin 1 Name">Admin 1 Name</div>, "value": branch.branchAdmin1Name, "mapping": "branchAdmin1Name", "maxLength": 40},
        {"label": <div xd-qa-type="label" xd-qa-name="Admin 1 Email">Admin 1 Email</div>, "value": branch.branchAdmin1Email, "mapping": "branchAdmin1Email", "maxLength": 60},
        {"label": <div xd-qa-type="label" xd-qa-name="Admin 2 Name">Admin 2 Name</div>, "value": branch.branchAdmin2Name, "mapping": "branchAdmin2Name", "maxLength": 40},
        {"label": <div xd-qa-type="label" xd-qa-name="Admin 2 Email">Admin 2 Email</div>, "value": branch.branchAdmin2Email, "mapping": "branchAdmin2Email", "maxLength": 60},
    ]
};

export const parseBranchDisplayData = ({branch}) => {
    return [
        {"label": <div xd-qa-type="label" xd-qa-name="Line 1">Line 1</div>, "value": branch.branchDisplay1, "mapping": "branchDisplay1", "maxLength": 80},
        {"label": <div xd-qa-type="label" xd-qa-name="Line 2">Line 2</div>, "value": branch.branchDisplay2, "mapping": "branchDisplay2", "maxLength": 80},
        {"label": <div xd-qa-type="label" xd-qa-name="Line 3">Line 3</div>, "value": branch.branchDisplay3, "mapping": "branchDisplay3", "maxLength": 80},
        {"label": <div xd-qa-type="label" xd-qa-name="Line 4">Line 4</div>, "value": branch.branchDisplay4, "mapping": "branchDisplay4", "maxLength": 80},
        {"label": <div xd-qa-type="label" xd-qa-name="Line 5">Line 5</div>, "value": branch.branchDisplay5, "mapping": "branchDisplay5", "maxLength": 80},
        {"label": <div xd-qa-type="label" xd-qa-name="Line 6">Line 6</div>, "value": branch.branchDisplay6, "mapping": "branchDisplay6", "maxLength": 80},
    ]
};
